module.exports = __webpack_public_path__ + "img/IMG_2555-2.a854c038.jpg";